import ModalShareAccessToPatient from "./ModalShareAccessToPatient";

export default ModalShareAccessToPatient;